import { CreditCard, Globe, Monitor, Smartphone } from "lucide-react";
import TechCard from "./TechCard";
import SectionKicker from "./SectionKicker";
import useScrollFade from "../hooks/useScrollFade";
import { technology } from "../data/content";

// Icons paired by position with technology.cards (Mobile apps, Web platforms, Backend and APIs, Payments and real-time).
const icons = [Smartphone, Monitor, Globe, CreditCard];

export default function TechnologySection() {
  const [ref] = useScrollFade();

  return (
    <section id="technology" className="relative overflow-hidden px-6 py-24 md:py-32">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-24 top-0 h-80 w-80 rounded-full bg-omnyx-cyan/10 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-omnyx-teal/10 blur-3xl"
      />

      <div className="relative mx-auto max-w-site text-center">
        <SectionKicker index="02" label="Technology" />
        <h2 className="font-heading text-4xl font-extrabold tracking-tightest text-site-ink md:text-5xl">
          {technology.title}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-site-muted">
          {technology.subtitle}
        </p>

        <div ref={ref} className="mt-14 grid gap-6 text-left sm:grid-cols-2 lg:grid-cols-4">
          {technology.cards.map((card, i) => (
            <TechCard
              key={card.title}
              icon={icons[i]}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
